var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"login-hint box fixed-width mt-4 centered"},[_c('h2',[_vm._v("Vous avez déjà un compte sur Coloc'Auto ?")]),_c('b-btn',{attrs:{"to":"/login","variant":"outline-primary"}},[_vm._v(" Se connecter ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }